import * as React from 'react';
import DiamondEmptyOutlined from './diamond-empty-outlined';
import DiamondEmptyFilled from './diamond-empty-filled';
import type { IconCombinedProps } from './types';
const DiamondEmptyCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <DiamondEmptyFilled ref={ref} {...rest} />;
  }
  return <DiamondEmptyOutlined ref={ref} {...rest} />;
});
export default DiamondEmptyCombined;